import { render, staticRenderFns } from "./customizationEdition.vue?vue&type=template&id=276976b9"
import script from "./customizationEdition.vue?vue&type=script&lang=js"
export * from "./customizationEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports